<template>
  <div>
    <controls></controls>
    <data-table :items="reportItems" :fields="reportFields"></data-table>
  </div>

</template>

<script>
import Controls from './Controls'
import DataTable from './DataTable'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'report',
  data () {
    return {}
  },
  components: {
    DataTable,
    Controls
  },
  watch: {
    '$route.params.name' () {
      this.changeReportItem(this.$store.state.route.params.name)
      this.setReportItemsToZero()
      this.getReportParams()
      this.cancelSourceToken({ message: 'Operation canceled by the user' })
    }
  },
  mounted () {
    this.changeReportItem(this.$store.state.route.params.name)
    this.setReportItemsToZero()
    this.getReportParams()
  },
  beforeRouteLeave (to, from, next) {
    this.cancelSourceToken({ message: 'Operation canceled by the user' })
    next()
  },
  computed: {
    ...mapState(
      {
        menuReportItems: state => state.reports.reportMenuItems,
        reportFields: state => state.reports.reportFields,
        reportItems: state => state.reports.reportItems
      }
    )
  },
  methods: {
    ...mapActions('reports',
      [
        'getReportParams'
      ]
    ),
    ...mapMutations('reports',
      [
        'changeReportItem',
        'setReportItemsToZero',
        'cancelSourceToken'
      ]
    )
  }
}
</script>

<style scoped>

</style>
